export const onRouteUpdate = ({ location }) => {
  const lang = location.pathname.startsWith("/en") ? "en" : "pl"
  document.documentElement.lang = lang
}
